var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-row',{attrs:{"justify":"center"}},[(_vm.imgSrc)?_c('img',{style:({ width: '486px' }),attrs:{"height":"56","width":"486","src":_vm.imgSrc}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }